import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="local-time"
export default class extends Controller {
  static values = { 
    datetime: String,
    showWeekday: { type: Boolean, default: true }
  }

  connect() {
    this.updateToLocalTime()
  }

  updateToLocalTime() {
    if (!this.datetimeValue) return

    try {
      const date = new Date(this.datetimeValue)
      
      // Format the date in user's local timezone
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }
      
      // Add weekday only if showWeekday is true
      if (this.showWeekdayValue) {
        options.weekday = 'long'
      }
      
      const localizedDate = date.toLocaleDateString(undefined, options)
      this.element.textContent = localizedDate
      
      // Add timezone info as tooltip
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      this.element.setAttribute('title', `${localizedDate} (${timezone})`)
      
    } catch (error) {
      console.error('Error formatting local time:', error)
      // Fallback to original server-formatted time if error occurs
    }
  }
}
